import { render, staticRenderFns } from "./xbn_airdrop_v2.vue?vue&type=template&id=3f66684c&"
import script from "./xbn_airdrop_v2.vue?vue&type=script&lang=js&"
export * from "./xbn_airdrop_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports